module.exports = __webpack_public_path__ + "img/register-logo.f7b7ed66.jpg";